module.exports = __webpack_public_path__ + "assets/img/vision.d348ac7f.png";